module.exports = __webpack_public_path__ + "static/img/productPartner_12_1.3969173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_12_1.png
// module id = /H6L
// module chunks = 34